import store from "../store";
import { ADD_TOAST } from "./actionTypes";

// Pass duration = -1 for permanent Toast
export default function AddToast(
  text,
  importance = "failure",
  duration = 5000
) {
  store.dispatch({
    type: ADD_TOAST,
    toast: {
      text,
      duration,
      importance,
    },
  });
}
